<template>
    <div class="publicizeList flex-sub flex flex-direction">
        <div class="list-box flex-sub flex flex-direction">
            <van-pull-refresh class="flex-sub" v-model="refreshing" @refresh="onRefresh">
                <van-list
                    v-model="loading"
                    :finished="finished"
                    class="list-container"
                    finished-text="没有更多了"
                    @load="onLoad">
                    <div v-for="item in lists" :key="item.id" class="item"
                         @click="to('/h5/masses/detail',item.id,type)">
                        <div class="item-title ovHide2">{{ item.title }}</div>

                        <div class="item-cont">
                            <div class="item-time ovHide">
                                来源：{{ item.resource }}
                            </div>
                            <div class="item-time margin-left" style="flex-shrink: 0">
                                {{ item.publish_time }}
                            </div>
                        </div>
                    </div>
                </van-list>
            </van-pull-refresh>
        </div>
    </div>
</template>
<script>
import {masses_article_lst} from "@/api";

export default {
    name: "technologyList",
    data() {
        return {
            type: 1,
            search: {
                keyword: '',
                page: 1,
                limit: 30,
                total: 0,
            },
            lists: [],
            loading: false,
            finished: false,
            refreshing: false,
        }
    },
    components: {},
    created() {
        this.type = this.$route.query.type
    },
    methods: {

        async onLoad() {
            if (this.refreshing) {
                this.lists = [];
                this.search.page = 1
                this.refreshing = false;
            }
            let _data = await masses_article_lst(
                this.search.page,
                this.search.limit,
                this.type
            );
            if (_data.status === 200) {
                this.lists = [...this.lists, ..._data.data.data]
                if (this.lists.length >= _data.data.total) {
                    this.finished = true;
                }
                this.search.page += 1
                this.search.total = _data.data.total
            }else{
                this.lists=[]
                this.search.total = 0
                this.finished = true;
            }
        },
        onRefresh() {
            // 清空列表数据
            this.finished = false;
            this.loading = true;
            this.onLoad();
        },
        searchFun() {
            this.refreshing = true
            this.search.page = 1
            this.list()
        },
        to(path, id, type) {
            this.$router.push({
                path: path,
                query: {
                    id: id,
                    type: type
                }
            })
        },
    },
    watch: {},
    filters: {}
}
</script>

<style lang="scss" scoped>
.publicizeList {
    background: #ebf4ff;
    padding: 2.9vw 3.5vw;
    .search-box {
        width: 100%;
        height: 10.1vw;
        background-color: #ffffff;
        box-shadow: 0.7vw 0.5vw 2.4vw 0vw
        rgba(0, 46, 108, 0.17);
        border-radius: 1.3vw;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 3vw;
        position: sticky;
        top: 2.9vw;
        z-index: 2;
        .btn {
            width: 14.7vw;
            height: 7.5vw;
            background-color: #2d94ff;
            border-radius: 1.3vw;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 3.7vw;
            color: #ffffff;
            cursor: pointer;
        }

        .iconfont {
            color: #999999;
            font-size: 3.7vw;
            margin-right: 3vw;
        }
        input {
            flex: 1;
            height: 10.1vw;
            font-size: 3.7vw;
            color: #333333;
        }
    }


    .list-container {
        width: 100%;
        display: flex;
        flex-direction: column;

        .item {
            width: 100%;
            background: #ffffff;
            border-radius: 8px;
            padding: 4vw;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            min-height:28.1vw;
            margin-bottom: 2.7vw;
            .item-title {
                width: 100%;
                font-size: 3.7vw;
                font-weight: 600;
                line-height: 5.9vw;
                color: #141c24;
            }

            .item-cont {
                display: flex;
                align-items: center;
                justify-content: space-between;


                .item-time {
                    font-size: 3.2vw;
                    color: #9c9fa2;
                }
            }

        }
    }

}
</style>


